import { render } from "./PricePage.vue?vue&type=template&id=40e801d3&scoped=true"
import script from "./PricePage.vue?vue&type=script&lang=js"
export * from "./PricePage.vue?vue&type=script&lang=js"

import "./PricePage.vue?vue&type=style&index=0&id=40e801d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e801d3"]])

export default __exports__